import React from 'react';
import { Sidebar } from '@/components/Sidebar';
import { AppDrawers } from '@/pages/AppDrawers';
import type { MainLayoutProps } from '@/types';

export function MainLayout({ children }: MainLayoutProps) {
  return (
    <div className="flex h-dvh bg-background overflow-hidden">
      <Sidebar />
      <main className="flex-1 overflow-hidden flex flex-col">
        {children}
      </main>
      <AppDrawers />
    </div>
  );
}

